webpackJsonp([25],{

/***/ 1007:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_form_vue__ = __webpack_require__(828);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f70fea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_form_vue__ = __webpack_require__(1010);
function injectStyle (ssrContext) {
  __webpack_require__(1008)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23f70fea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f70fea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1009);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("9ef24da0", content, true);

/***/ }),

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.active-tab[data-v-23f70fea]{color:#fff}", "", {"version":3,"sources":["/opt/buildhome/repo/src/components/template/template-form.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,sBAAyB,AACzB,uCAAwC,AACxC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,wCAAyC,AACzC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,0BAA6B,AAC7B,8CAA+C,AAC/C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,2CAA4C,AAC5C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,+CAAgD,AAChD,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,4CAA6C,AAC7C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,6BACE,UAAa,CACd","file":"template-form.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_bold';\n  src: url(\"/static/fonts/Lato-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_light';\n  src: url(\"/static/fonts/Lato-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n.active-tab[data-v-23f70fea] {\n  color: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{staticClass:"mt-5",attrs:{"right":"","dark":"","color":"cyan"}},[_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab.id,attrs:{"active-class":"active-tab"}},[_vm._v("\n        "+_vm._s(tab.name)+"\n      ")])}),_vm._v(" "),_vm._l((_vm.tabs),function(tab){return _c('v-tab-item',{key:tab.id},[(tab.id === 1)?_c('v-layout',{attrs:{"row":"","wrap":"","ma-5":""}},[(_vm.flagCompanyParent)?_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('v-select',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"Compañía maestra","item-text":"nombreComercial","item-value":"id","items":_vm.masterCompanies},model:{value:(_vm.model.masterCompany),callback:function ($$v) {_vm.$set(_vm.model, "masterCompany", $$v)},expression:"model.masterCompany"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","mr-5":"","mb-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"Nombre Comercial","required":"","error":_vm.$v.model.nameCommercial.$error},model:{value:(_vm.model.nameCommercial),callback:function ($$v) {_vm.$set(_vm.model, "nameCommercial", $$v)},expression:"model.nameCommercial"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"Razón Social","error":_vm.$v.model.businessName.$error},model:{value:(_vm.model.businessName),callback:function ($$v) {_vm.$set(_vm.model, "businessName", $$v)},expression:"model.businessName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","mr-5":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"Código de Compañia","error":_vm.$v.model.codeCompany.$error},model:{value:(_vm.model.codeCompany),callback:function ($$v) {_vm.$set(_vm.model, "codeCompany", $$v)},expression:"model.codeCompany"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","mb-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"País","item-text":"name","item-value":"id","items":_vm.countries},model:{value:(_vm.model.country),callback:function ($$v) {_vm.$set(_vm.model, "country", $$v)},expression:"model.country"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","mb-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"Ruc","type":"number","error":_vm.$v.model.ruc.$error},model:{value:(_vm.model.ruc),callback:function ($$v) {_vm.$set(_vm.model, "ruc", $$v)},expression:"model.ruc"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","mb-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"Dominio"},model:{value:(_vm.model.domain),callback:function ($$v) {_vm.$set(_vm.model, "domain", $$v)},expression:"model.domain"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","mb-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"Plan","item-text":"name","item-value":"id","items":_vm.plans},model:{value:(_vm.model.typePlan),callback:function ($$v) {_vm.$set(_vm.model, "typePlan", $$v)},expression:"model.typePlan"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","mb-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"Rubro","item-text":"name","item-value":"id","items":_vm.rubros},model:{value:(_vm.model.heading),callback:function ($$v) {_vm.$set(_vm.model, "heading", $$v)},expression:"model.heading"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","mb-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Documento","items":_vm.codesDocuments,"returnObject":false},model:{value:(_vm.document.typeDocumentCode),callback:function ($$v) {_vm.$set(_vm.document, "typeDocumentCode", $$v)},expression:"document.typeDocumentCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","mb-3":"","ml-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Serie","type":"text","placeholder":"00","required":""},model:{value:(_vm.document.serie),callback:function ($$v) {_vm.$set(_vm.document, "serie", $$v)},expression:"document.serie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","mb-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Número","type":"text","placeholder":"00","required":""},model:{value:(_vm.document.number),callback:function ($$v) {_vm.$set(_vm.document, "number", $$v)},expression:"document.number"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","mb-3":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.validateDocument}},[_vm._v(" Validar ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","mb-3":"","ml-3":""}},[_c('span',{class:_vm.model.documentParentId
                  ? 'caption green--text'
                  : ' caption grey--text'},[_vm._v("\n              "+_vm._s(_vm.model.documentParentId
                  ? 'Documento Valido'
                  : 'Documento no seleccionado')+"\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"color":"success","hide-details":"","label":"Desea trabajar con kardex"},model:{value:(_vm.model.flagKardex),callback:function ($$v) {_vm.$set(_vm.model, "flagKardex", $$v)},expression:"model.flagKardex"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","pl-2":""}},_vm._l((_vm.languages),function(value,key){return _c('v-flex',{key:key,attrs:{"xs3":""}},[_c('v-checkbox',{attrs:{"color":"primary","label":key},model:{value:(value.isSelected),callback:function ($$v) {_vm.$set(value, "isSelected", $$v)},expression:"value.isSelected"}})],1)}))],1):_c('v-layout',{attrs:{"row":"","wrap":"","ma-5":""}},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","type":"email","hide-details":"","label":"Email","error":_vm.$v.model.email.$error},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"Password","type":"password","error":_vm.$v.model.password.$error},model:{value:(_vm.model.password),callback:function ($$v) {_vm.$set(_vm.model, "password", $$v)},expression:"model.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"Roles","item-text":"name","item-value":"id","items":_vm.rols,"return-object":""},model:{value:(_vm.model.idRoleSelected),callback:function ($$v) {_vm.$set(_vm.model, "idRoleSelected", $$v)},expression:"model.idRoleSelected"}})],1)],1)],1)})],2),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.$v.$invalid || _vm.loading,"on-run-service":_vm.loading},on:{"accept-button-clicked":_vm.sendData,"cancel-button-clicked":_vm.closeModal}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1011:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":_vm.title,"value":true},on:{"close-modal":_vm.closeModal}},[_c('template-form',{attrs:{"role-id":_vm.id,"code-project":_vm.codeProject,"project-id":_vm.projectId,"code-template":_vm.templateCode}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_new_vue__ = __webpack_require__(827);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26dd8c2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_new_vue__ = __webpack_require__(1011);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_new_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26dd8c2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(544));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(543));

var _alphaNum = _interopRequireDefault(__webpack_require__(546));

var _numeric = _interopRequireDefault(__webpack_require__(547));

var _between = _interopRequireDefault(__webpack_require__(548));

var _email = _interopRequireDefault(__webpack_require__(549));

var _ipAddress = _interopRequireDefault(__webpack_require__(550));

var _macAddress = _interopRequireDefault(__webpack_require__(551));

var _maxLength = _interopRequireDefault(__webpack_require__(552));

var _minLength = _interopRequireDefault(__webpack_require__(553));

var _required = _interopRequireDefault(__webpack_require__(554));

var _requiredIf = _interopRequireDefault(__webpack_require__(555));

var _requiredUnless = _interopRequireDefault(__webpack_require__(556));

var _sameAs = _interopRequireDefault(__webpack_require__(557));

var _url = _interopRequireDefault(__webpack_require__(558));

var _or = _interopRequireDefault(__webpack_require__(559));

var _and = _interopRequireDefault(__webpack_require__(560));

var _not = _interopRequireDefault(__webpack_require__(561));

var _minValue = _interopRequireDefault(__webpack_require__(562));

var _maxValue = _interopRequireDefault(__webpack_require__(563));

var _integer = _interopRequireDefault(__webpack_require__(564));

var _decimal = _interopRequireDefault(__webpack_require__(565));

var helpers = _interopRequireWildcard(__webpack_require__(541));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","APP_CODE":'ACL001',"APP_NAME":'"ACL"',"QUIPU_URL":'undefined',"MOCK_URL":'https://jsonplaceholder.typicode.com',"ACL_URL":'https://acl.casamarketapp.com/api',"SALES_URL":'https://sales.apprunn.net',"ACL_URL_COMPANY":'https://midecommerce.casamarketapp.com',"STORAGE_USER_KEY":"acl","S3_IMAGES_URL":'//s3.amazonaws.com/apprunn-acl',"COMPANY_LOGIN_TITLE":'ACL',"COMPANY_LOGIN_BACKGROUND":'https://s3.amazonaws.com/apprunn-acl/bg-login.jpg',"ACCEPT_SERVICE_V2":'application/vnd.apiacl.v2+json'}).BUILD === 'web' ? __webpack_require__(545).withParams : __webpack_require__(152).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_template_form__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_helper__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//
//





var getLocalData = __WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].getLocalData;


function created() {
  this.idProject = this.projectId || getLocalData('project-id');
  this.templateCode = this.codeTemplate || getLocalData('code-template');
}

function closeModal() {
  this.goTo('page-template', {
    params: { projectId: this.idProject, codeProject: this.codeProject }
  });
}

function title() {
  return 'Nueva Compa\xF1ia <- ' + this.name;
}

function data() {
  return {
    idProject: 0,
    templateCode: 0
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-template-new',
  components: {
    actionSidebar: __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__["default"],
    templateForm: __WEBPACK_IMPORTED_MODULE_1__components_template_template_form__["a" /* default */]
  },
  computed: {
    title: title
  },
  created: created,
  data: data,
  methods: {
    closeModal: closeModal
  },
  props: {
    codeProject: {
      type: String,
      required: true
    },
    name: {
      type: String
    },
    id: {
      type: [Number, String]
    },
    projectId: {
      type: [Number, String]
    },
    codeTemplate: {
      type: [Number, String]
    }
  }
});

/***/ }),

/***/ 828:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_helper__ = __webpack_require__(79);



var loadRols = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var id, headers, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = this.$route.params.id;
            headers = {
              Accept: '' + 'application/vnd.apiacl.v2+json'
            };
            _context.prev = 2;
            _context.next = 5;
            return this.$http.get('project/' + this.codeProject + '/template/' + id + '/roles', { headers: headers });

          case 5:
            response = _context.sent;

            this.rols = response.data.data;
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](2);

            this.showError();

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 9]]);
  }));

  return function loadRols() {
    return _ref.apply(this, arguments);
  };
}();

var loadProjects = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return this.$http.get('project/' + this.idProject);

          case 3:
            response = _context2.sent;

            this.languages = response.data.data.languages;
            this.isCompanyParent(response.data.data);
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2['catch'](0);

            this.showError();

          case 11:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 8]]);
  }));

  return function loadProjects() {
    return _ref2.apply(this, arguments);
  };
}();

var loadCountries = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return this.$http.get('countries');

          case 3:
            response = _context3.sent;

            this.countries = response.data.data;
            _context3.next = 10;
            break;

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3['catch'](0);

            this.showError();

          case 10:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 7]]);
  }));

  return function loadCountries() {
    return _ref3.apply(this, arguments);
  };
}();

var loadItems = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
    var url, _ref5, items;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = 'project/' + this.codeProject + '/items';
            _context4.next = 3;
            return this.$http.get(url);

          case 3:
            _ref5 = _context4.sent;
            items = _ref5.data;
            this.rubros = items.data;

          case 6:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function loadItems() {
    return _ref4.apply(this, arguments);
  };
}();

var loadMasterCompanies = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
    var params, url, _ref8, response;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            params = { page: 1 };
            url = '/projects/' + this.codeProject + '/company-parent';
            _context5.next = 4;
            return this.$http.get(url, { params: params });

          case 4:
            _ref8 = _context5.sent;
            response = _ref8.data;

            this.masterCompanies = response.data;

          case 7:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function loadMasterCompanies() {
    return _ref7.apply(this, arguments);
  };
}();

var sendData = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
    var headers, body;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            this.loading = true;
            headers = {
              Accept: '' + 'application/vnd.apiacl.v2+json'
            };
            body = {
              codeCompany: this.model.codeCompany,
              codeProject: this.codeProject,
              codeTemplate: this.templateCode,
              idItem: this.model.heading,
              idRoleSelected: this.model.idRoleSelected ? this.model.idRoleSelected.typeRoleId : undefined,
              // codeUser: this.model.codeUser,
              companyParentId: this.model.masterCompany,
              countryId: this.model.country,
              email: this.model.email,
              flagAppCompany: true,
              flagKardex: this.model.flagKardex,
              languages: this.languages,
              domain: this.model.domain,
              nombreComercial: this.model.nameCommercial,
              password: this.model.password,
              razonSocial: this.model.businessName,
              ruc: this.model.ruc,
              typePlan: this.model.typePlan,
              documentParentId: this.model.documentParentId
            };
            _context6.prev = 3;
            _context6.next = 6;
            return this.$http.post('company-template', body, {
              headers: headers
            });

          case 6:
            this.showNotification('Se creó correctamente el template');
            this.closeModal();
            _context6.next = 14;
            break;

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6['catch'](3);

            if (_context6.t0.data.email) {
              this.showError(_context6.t0.data.email);
            }
            // if (err.data.codeUser) {
            // 	this.showError(err.data.codeUser);
            // }
            if (_context6.t0.data.codeCompany) {
              this.showError(_context6.t0.data.codeCompany);
            }

          case 14:
            _context6.prev = 14;

            this.loading = false;
            return _context6.finish(14);

          case 17:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this, [[3, 10, 14, 17]]);
  }));

  return function sendData() {
    return _ref9.apply(this, arguments);
  };
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var getLocalData = __WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].getLocalData;


function validations() {
  var validation = {
    model: {
      nameCommercial: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      businessName: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      codeCompany: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      ruc: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      typePlan: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      }
      // codeUser: {
      // 	required,
      // },
    }
  };
  return validation;
}

function closeModal() {
  this.goTo('page-template', {
    params: { projectId: this.projectId, codeProject: this.codeProject }
  });
}

function created() {
  this.idProject = this.projectId || getLocalData('project-id');
  this.templateCode = this.codeTemplate || getLocalData('code-template');
  this.loadProjects();
  this.loadCountries();
  this.loadItems();
  this.loadRols();
  this.loadPlans();
  // this.loadDistributors();
}

function isCompanyParent(_ref6) {
  var flagCompanyParent = _ref6.flagCompanyParent;

  if (flagCompanyParent) {
    this.flagCompanyParent = flagCompanyParent;
    this.loadMasterCompanies();
  }
}

function data() {
  return {
    countries: [],
    // listDistributors: [],
    flagCompanyParent: 0,
    idProject: 0,
    loading: false,
    masterCompanies: [],
    model: {
      businessName: '',
      codeCompany: '',
      codeUser: '',
      country: '',
      domain: '',
      email: '',
      flagKardex: false,
      masterCompany: 0,
      nameCommercial: '',
      password: '',
      ruc: '',
      typePlan: null,
      heading: null,
      idRoleSelected: null,
      // idDistributor: null,
      documentParentId: null
    },
    tabs: [{ id: 1, name: 'Datos Compañía' }, { id: 2, name: 'Datos Usuario' }],
    rubros: [],
    plans: [],
    rols: [],
    templateCode: 0,
    codesDocuments: ['BOL', 'NTV', 'FAC'],
    document: {
      serie: null,
      number: null,
      typeDocumentCode: null
    }
  };
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'template-form',
  created: created,
  data: data,
  methods: {
    closeModal: closeModal,
    isCompanyParent: isCompanyParent,
    loadCountries: loadCountries,
    loadItems: loadItems,
    loadProjects: loadProjects,
    loadMasterCompanies: loadMasterCompanies,
    loadRols: loadRols,
    sendData: sendData,
    loadPlans: function loadPlans() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this.$http.get('type-plans');

              case 2:
                response = _context7.sent;

                _this.plans = response.data.data;

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this);
      }))();
    },

    // async loadDistributors() {
    //   try {
    //     const response = await this.$http.get('distributaries');
    //     this.listDistributors = response.data.data;
    //   } catch (error) {
    //     this.showError(error);
    //   }
    // },
    validateDocument: function validateDocument() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var _document, serie, number, typeDocumentCode, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _document = _this2.document, serie = _document.serie, number = _document.number, typeDocumentCode = _document.typeDocumentCode;
                _context8.prev = 1;
                _context8.next = 4;
                return _this2.$httpSales.post('subsidiaries/billing-document', { serie: serie, number: number, typeDocumentCode: typeDocumentCode }, _this2.configFetchValidateDoc || undefined);

              case 4:
                response = _context8.sent;

                _this2.model.documentParentId = response.data.id;
                _this2.showNotification('El documento es válido y registrado');
                _context8.next = 13;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](1);

                _this2.model.documentParentId = null;
                _this2.showError('El documento no se encuentra registrado');

              case 13:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this2, [[1, 9]]);
      }))();
    }
  },
  computed: {
    configFetchValidateDoc: function configFetchValidateDoc() {
      var _this3 = this;

      try {
        var company = this.masterCompanies.find(function (c) {
          return c.id === _this3.model.masterCompany;
        });
        if (!company || company && !company.template) {
          return null;
        }
        var domains = company.template.data.settings.domains || [];
        var saleDomain = domains.find(function (d) {
          return d.code === 'SALES_URL';
        });
        var baseURL = saleDomain ? saleDomain.endPoint : 'https://sales.apprunn.net';

        return {
          baseURL: baseURL,
          headers: {
            Authorization: 'Bearer ' + company.hash
          }
        };
      } catch (error) {
        return null;
      }
    }
  },
  props: {
    projectId: {
      type: [Number, String]
    },
    codeProject: {
      type: String
    },
    codeTemplate: {
      type: [Number, String]
    }
  },
  validations: validations
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/25.14bb4ef84b8e4edacb27.js